






















import DatePicker from '@reciprocity/date-picker';

import { filterPresenterMixin } from './common';

export default {
  name: 'DateTimeFilterAttributePresenter',
  components: {
    DatePicker,
  },
  props: {
    ...filterPresenterMixin.props,
  },
  data() {
    return {
      // TODO: to constant and reuse in datetime presenter
      format: 'M/D/YYYY h:mm A',
    };
  },
  computed: {
    computedValue: {
      get(): string {
        return this.value;
      },
      set(date: string): void {
        this.$emit('input', date);
      },
    },
  },
};
